<template>
  <div>
    <!-- Tabs -->
    <div class="tabs-container">
      <v-sheet elevation="2" class="p-4">
        <v-slide-group
          v-if="visibleTabs.length > 1"
          v-model="step"
          show-arrows
          class="tab-group"
        >
          <template #prev>
            <v-btn variant="flat" class="nav-btn">
              <span style="color: #24316d; font-size: 20px">&lt;</span>
            </v-btn>
          </template>

          <template #next>
            <v-btn variant="flat" class="nav-btn">
              <span style="color: #24316d; font-size: 20px">&gt;</span>
            </v-btn>
          </template>

          <v-slide-group-item
            v-for="(tab, index) in visibleTabs"
            :key="index"
            class="tab-item"
          >
            <v-btn
              :variant="step === index ? 'elevated' : 'outlined'"
              @click="changeTab(index)"
              :class="['mx-1', { 'valid-tab': isTabValid(index) }]"
            >
              {{ tab }}
              <span v-if="isTabValid(index)" class="ml-1">✓</span>
            </v-btn>
          </v-slide-group-item>
        </v-slide-group>
      </v-sheet>
    </div>

    <div v-for="(tab, index) in visibleTabs" :key="index" class="margincard">
      <div
        v-if="step === index"
        class="d-flex justify-content-center align-items-center flex-column"
      >
        <div class="col-lg-8 col-sm-12 col-md-10 borderPointier mb-2">
          <div class="background-white">
            <div class="title text-center">
              <div class="position">{{ $t("INSTALLATEUR") }} - {{ tab }}</div>
            </div>
          </div>

          <!-- Form -->
          <form class="my-4 w-100">
            <div class="center">
              <b-form-group
                :label="$t('QUESTION_SOUE-TRAITANT')"
                class="form-input custom-placeholder legend mt-3"
              >
                <div
                  class="d-flex form-input custom-placeholder custom-input mb-3"
                >
                  <b-form-radio
                    v-model="stepsData[index].selected"
                    class="mb-3 mx-2"
                    name="some-radios"
                    :value="'A'"
                    @change="watchStepSelection(index, 'A')"
                  >
                    {{ $t("YES") }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="stepsData[index].selected"
                    class="mb-3 mx-2"
                    name="some-radios"
                    :value="'B'"
                    @change="watchStepSelection(index, 'B')"
                  >
                    {{ $t("NO") }}
                  </b-form-radio>
                </div>
              </b-form-group>
              <div v-if="stepsData[index].selected === 'B'">
                <div class="d-flex align-items-center justify-content-start">
                  <div>{{ $t("Choisir_sous-traitant") }} *</div>
                </div>
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-group class="my-4 flex-grow-1">
                    <multiselect
                      v-model="stepsData[index].selectedSousTraitantData"
                      :searchable="false"
                      :close-on-select="true"
                      :multiple="false"
                      :options="getAllsousTraitant"
                      label="name"
                      track-by="id"
                      :placeholder="$t('SELECTED_SOUE-TRAITANT')"
                      class="form-input custom-placeholder custom-input"
                      @input="handleSelectionChange(index)"
                    />
                  </b-form-group>
                  <button
                    style="flex-shrink: 0"
                    id="add-wit-popover"
                    class="mb-1 mx-3 py-0 newstore rounded"
                    @click.prevent="handleStore()"
                  >
                    +
                  </button>
                </div>
                <b-popover
                  target="add-wit-popover"
                  placement="top"
                  triggers="hover focus"
                >
                  {{ $t("Vous pouvez ajouter un sous-traitant") }}
                </b-popover>

                <storeModalVue @updateList="setup(true)"></storeModalVue>

                <b-form-group :label="$t('Nom_Sous-Traitant')">
                  <b-form-input
                    v-model="stepsData[index].selectedSousTraitantData.name"
                    :placeholder="$t('Nom_Sous-Traitant')"
                    class="form-input custom-placeholder custom-input"
                    oninput="this.value = this.value.toUpperCase()"
                  ></b-form-input>
                </b-form-group>

                <b-form-group :label="$t('SIRET_Sous-Traitant')">
                  <b-form-input
                    v-model="
                      stepsData[index].selectedSousTraitantData.num_siret
                    "
                    type="number"
                    @keydown="(event) => onKeyDown(event)"
                    :placeholder="$t('SIRET_Sous-Traitant')"
                    class="form-input custom-placeholder custom-input"
                    oninput="this.value = this.value.toUpperCase()"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="my-3">{{ $t("RGE") }} *</div>

            <div class="d-flex align-items-center justify-content-start">
              <b-form-group label-for="num_rge" class="mb-5 flex-grow-1">
                <multiselect
                  v-model="stepsData[index].selectedCertificat"
                  :searchable="true"
                  :close-on-select="true"
                  :multiple="false"
                  :options="getAllCertificatRges"
                  label="num"
                  track-by="id"
                  :placeholder="$t('Sélectionne RGE')"
                  class="form-input custom-placeholder custom-input"
                  @input="handleSelectionChangeRGE(index)"
                />
              </b-form-group>

              <button
                id="add-with-popover"
                class="mb-5 mx-3 py-0 newstore rounded"
                @click.prevent="openModal()"
                style="flex-shrink: 0"
              >
                +
              </button>
            </div>

            <certificatRGEmodal
              @updateList="
                setup(
                  true,
                  stepsData[index].selected,
                  stepsData[index].selectedSousTraitantData
                )
              "
            ></certificatRGEmodal>
            <b-popover
              target="add-with-popover"
              placement="top"
              triggers="hover focus"
            >
              {{
                $t(
                  "Vous pouvez ajouter un certificat à votre entreprise/sous-traitant"
                )
              }}
            </b-popover>
          </form>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>

      <b-button
        type="submit"
        @click="goToNextStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}

        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
    <Snackbar ref="snackbar" class="mt-5" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import storeModalVue from "@/components/Ajoutmodel/sousTraitantmodal.vue";
import Snackbar from "@/components/ui/errorSnackbar.vue";
import certificatRGEmodal from "@/components/Ajoutmodel/certificatRGEmodal.vue";
import {preventExceedingLength} from "@/utils/inputUtils";

export default {
  components: {
    storeModalVue,
    Snackbar,
    certificatRGEmodal,
  },
  props: {
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      endStep: false,
      previousStep: 0,
      update_EntiteExterne: null,
      step: 0,
      errorMessage: "",
      isLoading: false,
      stepsData: [],
      tabs: [
        "Isolation de combles ou de toiture",
        "Isolation des murs",
        "Isolation d’un plancher",
        "Fenêtre ou porte-fenêtre complète avec vitrage isolant",
      ],
      stepActiv: [
        "Isolation des murs",
        "Pompe à chaleur de type air/eau",
        "Isolation de combles ou de toiture",
      ],
    };
  },
  watch: {
    step(newVal) {
      this.fetchDataForStep(newVal);
    },
    selectedSousTraitantData(newVal) {
      if (this.selected === "B") {
        this.fetchData(
          this.selected,
          this.stepsData[newVal].selectedSousTraitantData.id,
          this.selected
        );
      }
      if (this.selected === "A") {
        this.fetchData(this.selected);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getOnlineUser",
      "getdevisMonoFiche",
      "getAllsousTraitant",
      "getAllCertificatRges",
    ]),
    buttonText() {
      return this.visibleTabs.length <= 1
        ? this.$t("NEXT")
        : this.$t("CONFIRMER");
    },
    visibleTabs() {
      const groupeLigneDocument =
        this.getdevisMonoFiche?.data?.groupeLigneDocument || [];

      const typeGroups = groupeLigneDocument.map((item) => item.type_group);

      return typeGroups;
    },
  },

  created() {
    this.allsousTraitant({
      search: "",
      page: this.page,
      per_page: 100000,
      entreprise: this.getdevisMonoFiche.data.devis.entreprise,
    });
    this.initializeStepsData();
    this.fetchDataForStep(this.step);
  },
  methods: {
    ...mapActions([
      "allsousTraitant",
      "setDevisMonoFiche",
      "updateGroupe",
      "allCertificatRge",
      "edit_sousTraitant",
      "store_sousTraitant",
    ]),
    isTabValid(index) {
      const stepData = this.stepsData[index];
      if (!stepData) return false;
      
      return stepData.selectedCertificat?.id !== null && stepData.selectedCertificat?.id !== undefined;
    },
    onKeyDown(event) {
      preventExceedingLength(event);
    },
    changeTab(newIndex) {
      if (newIndex !== this.step) {
        if (
          this.stepsData[this.step].selected == "A" &&
          !this.stepsData[this.step].selectedCertificat.id
        ) {
       
          this.$refs.snackbar.showSnackbar(
  `${this.$t("Il faut ajouter un certificat RGE")} ${this.visibleTabs[this.step]}.`
);
          return;
        }
        if (
          this.stepsData[this.step].selected == "B" &&
          (!this.stepsData[this.step].selectedCertificat.id ||
            !this.stepsData[this.step].selectedSousTraitantData.id)
        ) {
          this.$refs.snackbar.showSnackbar(
  `${this.$t("Il faut ajouter un certificat RGE et un sous-traitant au")} ${this.visibleTabs[this.step]}.`
);


          return;
        }

        this.previousStep = this.step;
        this.step = newIndex;
        this.goToStep(this.previousStep);
      }
    },
    openModal() {
      this.$root.$emit("bv::show::modal", "certificatRGEmodal");
    },
    handleStore() {
      this.$root.$emit("bv::show::modal", "sousTraitantModal");
    },
    closeModal() {
      this.showModal = false;
      this.setup(true);
    },
    setup(refresh = false, selec, sous_traitantD) {
      if (refresh) this.page = 1;
      this.allsousTraitant({
        search: "",
        page: this.page,
        per_page: 100000,
        entreprise: this.getdevisMonoFiche.data.devis.entreprise,
      });
      this.fetchData(selec, sous_traitantD.id);
    },

    fetchDataForStep(step) {
      const currentStepData = this.stepsData[step];

      if (!currentStepData) {
        return;
      }

      const { selected, selectedSousTraitantData } = currentStepData;

      if (selected === "A") {
        this.fetchData("A");
      } else if (selected === "B" && selectedSousTraitantData?.id) {
        this.fetchData("B", selectedSousTraitantData.id);
      }
    },

    async fetchData(selected, sousTraitantId = null) {
      const baseParams = {
        page: 1,

        search: "",
      };

      if (selected === "A") {
        await this.allCertificatRge({
          ...baseParams,
          per_page: 10000000,
          entreprise_id: this.getdevisMonoFiche.data.devis.entreprise.id,
          sous_traitant_id: "",
        });
      } else if (selected === "B") {
        if (sousTraitantId === null) {
          await this.allCertificatRge({
            page: 1,
            per_page: 0,
            sous_traitant_id: sousTraitantId || "",
            entreprise_id: "",
          });
        } else {
          await this.allCertificatRge({
            ...baseParams,
            per_page: 10000000,
            sous_traitant_id: sousTraitantId || "",
            entreprise_id: "",
          });
        }
      }
    },
    handleSelectionChange(index) {
      const selected = this.stepsData[index].selectedSousTraitantData;
      this.fetchData("B", selected.id);
      if (!selected || (selected && selected.id === null)) {
        this.fetchData("B", selected.id);
        this.stepsData[index].selectedSousTraitantData = {
          id: null,
          name: "",
          num_siret: "",
        };
      }
      this.stepsData[index].selectedCertificat = {
        id: null,
        num: null,
      };
    },
    handleSelectionChangeRGE(index) {
      const selectedRGE = this.stepsData[index].selectedCertificat;
      if (!selectedRGE || (selectedRGE && selectedRGE.id === null)) {
        this.stepsData[index].selectedCertificat = {
          id: null,
          num: "",
        };
      }
    },
    watchStepSelection(index, selected) {
      if (selected === "A") {
        this.updateStepSousTraitant(index, null);
        this.fetchData(selected);
        this.stepsData[index].selectedCertificat = {
          id: null,
          num: null,
        };
      }
      if (selected === "B") {
        this.fetchData(selected);
        this.stepsData[index].selectedCertificat = {
          id: null,
          num: null,
        };
      }
    },
    updateStepSousTraitant(index, value) {
      const stepData = this.stepsData[index];

      if (value && Object.keys(value).length > 0) {
        stepData.selectedSousTraitantData = { ...value };
        this.fetchData("B", this.stepsData[index].selectedSousTraitantData.id);
        this.stepsData[index].selectedCertificat = {
          id: null,
          num: null,
        };
        this.getdevisMonoFiche.data.groupeLigneDocument[index].sous_traitant = {
          ...value,
        };
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].sous_traitant_id = value.id;
      } else {
        stepData.selectedSousTraitantData = {
          id: null,
          name: "",
          num_siret: "",
        };
        this.getdevisMonoFiche.data.groupeLigneDocument[index].sous_traitant = {
          id: null,
          name: "",
          num_siret: "",
        };
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].sous_traitant_id = null;
        this.fetchData("A");
        this.stepsData[index].selectedCertificat = {
          id: null,
          num: null,
        };
      }
    },
    checkStepsData() {
      const invalidSteps = this.stepsData
        .map((step, index) => {
          if (!step.selectedCertificat?.id) {
            const typeTravail =
              this.getdevisMonoFiche.data.groupeLigneDocument[index]
                ?.type_group;
            return typeTravail
              ? typeTravail
              : `Type de travail inconnu (index ${index})`;
          }
          return null;
        })
        .filter((typeTravail) => typeTravail !== null);

      if (invalidSteps.length > 0) {

        this.$refs.snackbar.showSnackbar(
  `${this.$t("Il faut remplir le(s) étapes suivant(s) :")} ${invalidSteps.join(", ")}.`
);

        return false;
      }

      return true;
    },
    initializeSousTraitant(index) {
      const sousTraitant =
        this.getdevisMonoFiche?.data?.groupeLigneDocument[index]
          ?.sous_traitant || {};
      if (
        this.getdevisMonoFiche?.data?.groupeLigneDocument[index]?.sous_traitant
      ) {
        this.fetchData("B", sousTraitant.id);
      } else {
        this.fetchData("A");
      }

      return {
        id: sousTraitant.id || null,
        name: sousTraitant.name || "",
        num_siret: sousTraitant.num_siret || "",
      };
    },
    initializeRGE(index) {
      const rge =
        this.getdevisMonoFiche?.data?.groupeLigneDocument[index]
          ?.selected_certificat_RGE || {};
      return {
        id: rge.id || null,
        num: rge.num || "",
      };
    },
    initializeStepsData() {
      this.stepsData = this.getdevisMonoFiche?.data?.groupeLigneDocument.map(
        (item, index) => {
          const sousTraitantData = this.initializeSousTraitant(index);
          const selected = sousTraitantData.id ? "B" : "A";
          const certificatRge = this.initializeRGE(index);

          return {
            index,
            selected,

            selectedSousTraitantData: sousTraitantData,
            selectedCertificat: certificatRge,
          };
        }
      );
    },
    async edit(index) {
      const stepData = this.stepsData[index];
      if (stepData.selected === "A") {
        const result = {
          id: this.getdevisMonoFiche.data.groupeLigneDocument[index].id,
          sous_traitant_id: null,
          certificat_rge_id: this.stepsData[index].selectedCertificat.id,
        };

        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].certificat_rge_id = this.stepsData[index].selectedCertificat.id;
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].selected_certificat_RGE = {
          id: this.stepsData[index].selectedCertificat.id,
          num: this.stepsData[index].selectedCertificat.num,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        await this.updateGroupe(result);

        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].selected_certificat_RGE = {
          id: this.stepsData[index].selectedCertificat.id,
          num: this.stepsData[index].selectedCertificat.num,
        };
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].sous_traitant_id = null;
        this.getdevisMonoFiche.data.groupeLigneDocument[index].sous_traitant =
          null;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else if (
        stepData.selected === "B" &&
        stepData.selectedSousTraitantData.id !== null
      ) {
        await this.edit_sousTraitant(stepData.selectedSousTraitantData);
        this.setDevisMonoFiche(this.getdevisMonoFiche);

        const result = {
          id: this.getdevisMonoFiche.data.groupeLigneDocument[index].id,
          sous_traitant_id: stepData.selectedSousTraitantData.id,
          certificat_rge_id: this.stepsData[index].selectedCertificat.id,
        };
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].selected_certificat_RGE_id =
          this.stepsData[index].selectedCertificat.id;

        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].certificat_rge_id = this.stepsData[index].selectedCertificat.id;
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].selected_certificat_RGE = {
          id: this.stepsData[index].selectedCertificat.id,
          num: this.stepsData[index].selectedCertificat.num,
        };
        await this.updateGroupe(result);
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].certificat_rge_id = this.stepsData[index].selectedCertificat.id;
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].selected_certificat_RGE = {
          id: this.stepsData[index].selectedCertificat.id,
          num: this.stepsData[index].selectedCertificat.num,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else {
        await this.createSousTraitant(index);
        this.getdevisMonoFiche.data.groupeLigneDocument[
          index
        ].selected_certificat_RGE = {
          id: this.stepsData[index].selectedCertificat.id,
          num: this.stepsData[index].selectedCertificat.num,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
      // this.this.checkCertificatRGE()
    },
    async createSousTraitant(index) {
      const res = await this.store_sousTraitant(
        this.stepsData[index].selectedSousTraitantData
      );

      this.getdevisMonoFiche.data.groupeLigneDocument[index].sous_traitant_id =
        res.data.id;
      this.getdevisMonoFiche.data.groupeLigneDocument[index].sous_traitant = {
        id: res.data.id,
        name: this.stepsData[index].selectedSousTraitantData.name,
        num_siret: this.stepsData[index].selectedSousTraitantData.num_siret,
      };
      const result = {
        id: this.getdevisMonoFiche.data.groupeLigneDocument[index].id,
        sous_traitant_id: res.data.id,
        certificat_rge_id: this.stepsData[index].selectedCertificat.id,
      };
      await this.updateGroupe(result);
      this.getdevisMonoFiche.data.groupeLigneDocument[index].certificat_rge_id =
        this.stepsData[index].selectedCertificat.id;
      this.getdevisMonoFiche.data.groupeLigneDocument[
        index
      ].selected_certificat_RGE = {
        id: this.stepsData[index].selectedCertificat.id,
        num: this.stepsData[index].selectedCertificat.num,
      };
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },

  async  goToStep(index) {
     
      this.isLoading = true;
     
       await this.edit(index);

        this.isLoading = false;
        if (index == this.visibleTabs.length) {
         await this.goToNextStep();
        }
        if (index + 1 == this.visibleTab.length - 1) {
          (this.previousStep = index + 1), (this.step = index + 2);
        }
      
    },
    async goToNextStep() {
      const stepNumber = this.visibleTabs?.length ?? 0;
      if (this.step !== stepNumber - 2) {
        if (!this.checkStepsData()) {
          return;
        }
      }

      if (this.step == stepNumber - 1) {
        this.edit(this.step);
      }

      this.stepsData.forEach((stepData, index) => {
        if (this.getdevisMonoFiche.data.groupeLigneDocument[index]) {
          this.getdevisMonoFiche.data.groupeLigneDocument[index].sous_traitant =
            stepData.selectedSousTraitantData || null;
        }
      });
              await new Promise(resolve => setTimeout(resolve, 500));

      const groupeLigneDocuments =
        this.getdevisMonoFiche.data.groupeLigneDocument || [];
      for (const ligne of groupeLigneDocuments) {
        if (
          ligne.selected_certificat_RGE === null &&
          ligne.sous_traitant === null
        ) {
          this.errorMessage =
             `${this.$t("Chaque étape doit être certifiée par un certificat RGE")}`;
          this.$refs.snackbar.showSnackbar(this.errorMessage);
          return;
        }
        if (ligne.selected_certificat_RGE  && ligne.sous_traitant?.id !== null) {
          this.errorMessage = "";
        }
      }
      for (const ligne of groupeLigneDocuments) {
        this.errorMessage = "";
        if (
          ligne.selected_certificat_RGE?.id === null ||
          ligne.selected_certificat_RGE === null
        ) {
     
          this.$refs.snackbar.showSnackbar(
  `${this.$t("L'étape")} ${ligne.type_group} ${this.$t("manque de données")}`
);


          return;
        }
      }

      this.$emit("changeStep", 4, true);
    },
    goToPrevStep() {
      this.$emit("changeStepPrev", 2);
    },
    async saveStepData(index) {
      this.stepsData[index];
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 14px;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid #24316d;
  color: #24316d;
  background-color: #fff;
}
/* Active tab: variant="elevated" */
.v-btn[variant="elevated"] {
  background-color: #24316d !important;
  color: #fff !important;
  border: 1px solid #24316d !important;
  box-shadow: 0 2px 6px rgba(36, 49, 109, 0.3) !important;
}
/* Inactive tab: variant="outlined" */
.v-btn[variant="outlined"] {
  background-color: #fff !important;
  color: #24316d !important;
  border: 1px solid #24316d !important;
  box-shadow: none !important;
}
/* Hover effect for all tabs */
.v-btn:hover {
  background-color: #eef1fd !important;
  color: #24316d !important;
}
.tab-group {
  max-width: 300px;
  margin: 0 auto;
}
@media (max-width: 600px) {
  .tab-group {
    max-width: 300px; 
  }
}

@media (min-width: 601px) {
  .tab-group {
    max-width: 600px; 
  }
}
.tab-item {
  text-align: center;
}

.nav-btn {
  background-color: white !important;
  box-shadow: none !important;
}

.tab {
  display: ruby;
}

.v-slide-group__wrapper {
  display: ruby;
}

.tabs-container {
  display: flex;
  justify-content: center;
}
.margincard {
  margin: inherit;
  width: -webkit-fill-available;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
  margin-bottom: 25px;
  margin: inherit;
  height: 100%;
  width: 90%;
}
.center .legend {
  font-size: 16px;
}
.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.custom-placeholder::placeholder {
  font-size: 13px;
}

.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}
.custom-input {
  box-shadow: none;
}
.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.index {
  z-index: 20 !important;
}
.small-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
}

/* Valid tab styling */
.v-btn.valid-tab {
  background-color: #4caf50 !important;
  color: #fff !important;
  border: 1px solid #4caf50 !important;
}

.v-btn.valid-tab[variant="outlined"] {
  background-color: #4caf50 !important;
  color: #fff !important;
  border: 1px solid #4caf50 !important;
}

.v-btn.valid-tab[variant="elevated"] {
  background-color: #4caf50 !important;
  color: #fff !important;
  border: 1px solid #4caf50 !important;
}

.v-btn.valid-tab:hover {
  background-color: #45a049 !important;
  color: #fff !important;
}
</style>
